import uniq from 'lodash/uniq'
import pluralize from '@/helpers/pluralize'

export default {
  computed: {
    isSingleVariant() {
      return this.product && this.product.single_variant === true
    },

    hasVariants() {
      return this.product && this.product.variants && this.product.variants.length > 0
    },

    hasCombinations() {
      return this.combinations.length > 0
    },

    validVariants() {
      if (!this.product || !Array.isArray(this.product.variants)) {
        return []
      } else if (!this.product.variants.length) {
        return []
      }

      return this.product.variants
        .filter(variant => {
          return Array.isArray(variant.option_values) && variant.option_values.length > 0
        })
    },

    hasValidVariants() {
      return this.validVariants.length > 0
    },

    selectedVariant() {
      if (this.isSingleVariant) {
        return this.product.variants[0]
      } else if (!this.hasVariants) {
        return {}
      } else if (!this.validVariants.length && this.product.variants.length > 0) {
        return this.product.variants[0]
      }

      let variants = this.validVariants

      for (let i in this.choosen) {
        if (!this.choosen.hasOwnProperty(i)) {
          continue
        }

        variants = variants.filter(variant => {
          const optionValue = variant.option_values.find(ov => ov.option.id === i)

          return optionValue && optionValue.id === this.choosen[i]
        })
      }

      if (variants.length !== 1) {
        return {}
      }

      return variants[0]
    },

    stocksCount() {
      if (!this.selectedVariant || !Array.isArray(this.selectedVariant.remainders)) {
        return 0
      }

      return uniq(
        this.selectedVariant.remainders
          .filter(r => r && r.quantity > 0)
          .map(r => r.stock_id)
      ).length
    },

    stocksCountLabel() {
      return pluralize(this.stocksCount, ['магазине', 'магазинах', 'магазинах'])
    },

    isInStock() {
      if (!this.shouldTrackInventory) {
        return true
      }

      return this.stocksCount > 0
    },

    shouldTrackInventory() {
      return false
    },
  },

  methods: {
    generateCombinations() {
      this.combinations = []

      if (this.isSingleVariant || !this.hasVariants) {
        return
      }

      this.validVariants.forEach(variant => {
        if (!variant.option_values || !variant.option_values.length) {
          return
        }

        variant.option_values.forEach(optionValue => {
          let index = this.combinations.findIndex(c => c.id === optionValue.option.id)

          if (index === -1) {
            index = this.combinations.push({
              id: optionValue.option.id,
              name: optionValue.option.name,
              values: [],
            })

            index -= 1
          }

          const valueIndex = this.combinations[index].values.findIndex(v => v.id === optionValue.id)

          if (valueIndex >= 0) {
            return
          }

          this.combinations[index].values.push({
            id: optionValue.id,
            name: optionValue.name,
          })
        })
      })

      this.pickFirstInStockVariant()
    },

    pickFirstInStockVariant() {
      let variant = this.validVariants.find(variant => {
        const index = variant.remainders.findIndex(r => r.quantity > 0)

        return index !== -1
      })

      if (!variant) {
        variant = this.validVariants[0]
      }

      if (!variant) {
        return
      }

      variant.option_values.forEach(optionValue => {
        this.$set(this.choosen, optionValue.option.id, optionValue.id)
      })
    },
  },

  data() {
    return {
      combinations: [],
      choosen: {},
    }
  }
}
